import React from 'react'

const Test = () => {
  return (
    <h1>Hello World from test website!</h1>
  )
}

export default Test